import { useEffect, useState } from 'react';

// Typing hook — types text once on mount, then holds.
export function useTyping(text: string, { speed = 38, delay = 400 } = {}) {
  const [n, setN] = useState(0);
  useEffect(() => {
    setN(0);
    let i = 0;
    let t: ReturnType<typeof setTimeout> | undefined;
    const start = setTimeout(function tick() {
      i += 1;
      setN(i);
      if (i < text.length) t = setTimeout(tick, speed + Math.random() * 30);
    }, delay);
    return () => { clearTimeout(start); clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);
  return { typed: text.slice(0, n), done: n >= text.length };
}

// Settle hook — after entrance animations have had time to play, switch them off
// so base (visible) styles win. Keeps content robust in captures/print.
export function useSettled(ms = 3600) {
  const [settled, setSettled] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSettled(true), ms);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return settled;
}

// Mobile-layout hook — matches the sub-700px single-column world where the
// scene-driven sections switch to their chips-above-scene mobile layouts.
// SSR-safe default: false (this site only client-renders, but keep it honest).
export function useIsMobile(query = '(max-width: 700px)') {
  const [mobile, setMobile] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMobile(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return mobile;
}
